export const myInfo = {
  addPaymentMethod: 'Add Payment Method',
  invoicedCustomer: 'Your company has an active invoice payment method',
  table: {
    emptyState: {
      header: 'No Payment Methods',
    },
    headers: {
      paymentMethod: 'PAYMENT METHOD',
      expirationDate: 'EXPIRATION DATE',
      default: 'DEFAULT'
    },
    expirationDate: 'Exp %expDate%',
    expired: 'Expired',
    paymentMethod: {
      Visa: 'Visa ending in %lastFourDigits%',
      MasterCard: 'Mastercard ending in %lastFourDigits%',
      Discover: 'Discover ending in %lastFourDigits%',
      'American Express': 'American Express ending in %lastFourDigits%',
      invoice: 'Invoice',
      achSubscription: '%cardType% ending in %lastFourDigits%',
      unsupported: 'Unsupported card ending in %lastFourDigits%',
      suspended: 'Suspended',
      delete: {
        confirmationPopup: {
          title: 'Delete Payment Method',
          content: 'Are you sure you want to delete this card?'
        },
        success: 'Payment method deleted'
      },
      default: {
        success: '%cardType% ending in %lastFourDigits% is now your default payment method.'
      }
    }
  },
  paymentModal: {
    header: 'Add a Payment Method',
    ACH: 'New Bank Account (ACH)',
    newCard: 'New Credit/Debit Card',
    disclaimer: 'Your default payment method will be charged daily for any outstanding balance on your account. Payment method usage is governed by our <b><a href="https://www.wonolo.com/customer-agreement" target=_blank>Terms of Service</a></b>',
    plaid: 'Plaid is the simplest way to add your bank account to Wonolo - Plaid is a financial integration service that is <b>safe</b>, <b>secure</b>, and <b>trusted</b> by hundreds of compaines. Just connect your account using your bank credentials below to begin making ACH payments!',
    plaidSupport: 'Don\'t see your bank listed with Plaid? Contact <b>BusinessSupport@wonolo.com</b> to add your account.',
    plaidConnect: 'Connect with Plaid',
    toasts: {
      success: 'Added payment method successfully'
    },
    creditCardForm: {
      header: 'Add Credit Card',
      nameOnCard: 'Name on Card',
      firstNamePlaceholder: 'First',
      lastNamePlaceholder: 'Last',
      cardInformation: 'Card Information',
      cardNumberLabel: 'Card Number',
      cardNumberPlaceholder: 'Card Number',
      expirationDateLabel: 'Expiration Date',
      expirationDatePlaceholder: 'MM/YYYY',
      securityCodeLabel: 'Security Code',
      securityCodePlaceholder: 'CVC',
      billingAddressLabel: 'Billing Address',
      billingAddressPlaceholder: 'Street Address',
      cityLabel: 'City',
      cityPlaceholder: 'City',
      stateLabel: 'State',
      statePlaceholder: 'State',
      zipLabel: 'Zip Code',
      zipPlaceholder: 'Zip',
      makeDefaultPayment: 'Make this my default payment method',
      disclaimer1: 'Your default payment method will be charged daily for any outstanding balance on your account. Payment method usage is governed by our <b><a href="https://www.wonolo.com/customer-agreement" target=_blank>Terms of Service</a></b>',
      disclaimer2: 'Credit card transactions will incur a 3% processing fee. This is a standard industry practice and covers the costs charged by credit card processors.',
      save: 'Save Card',
      errors: {
        firstName: 'Please enter a first name',
        lastName: 'Please enter a last name',
        cardNumber: 'Enter a valid card number',
        expirationDate: 'Enter a valid month and year',
        securityCode: 'Enter a valid security code',
        billingAddress: 'Please enter a street address',
        city: 'Please enter a city',
        state: 'Please enter a state',
        zipCode: 'Enter a valid zipcode'
      }
    },
  }
};
